// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file penumbra/core/component/sct/v1/sct.proto (package penumbra.core.component.sct.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { Message, proto3, protoInt64, Timestamp } from "@bufbuild/protobuf";
import { MerkleRoot, StateCommitment } from "../../../../crypto/tct/v1/tct_pb.js";
/**
 * Configuration data for the SCT component.
 *
 * @generated from message penumbra.core.component.sct.v1.SctParameters
 */
export class SctParameters extends Message {
    /**
     * The default duration of each epoch, in number of blocks.
     *
     * @generated from field: uint64 epoch_duration = 1;
     */
    epochDuration = protoInt64.zero;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.sct.v1.SctParameters";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "epoch_duration", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    ]);
    static fromBinary(bytes, options) {
        return new SctParameters().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SctParameters().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SctParameters().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SctParameters, a, b);
    }
}
/**
 * Sct-specific genesis content.
 *
 * @generated from message penumbra.core.component.sct.v1.GenesisContent
 */
export class GenesisContent extends Message {
    /**
     * The SctParameters present at genesis.
     *
     * @generated from field: penumbra.core.component.sct.v1.SctParameters sct_params = 1;
     */
    sctParams;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.sct.v1.GenesisContent";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "sct_params", kind: "message", T: SctParameters },
    ]);
    static fromBinary(bytes, options) {
        return new GenesisContent().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GenesisContent().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GenesisContent().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GenesisContent, a, b);
    }
}
/**
 * An epoch is a sequentially numbered collection of contiguous blocks.
 *
 * @generated from message penumbra.core.component.sct.v1.Epoch
 */
export class Epoch extends Message {
    /**
     * The unique index of the epoch.
     *
     * @generated from field: uint64 index = 1;
     */
    index = protoInt64.zero;
    /**
     * The starting height for the epoch.
     *
     * @generated from field: uint64 start_height = 2;
     */
    startHeight = protoInt64.zero;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.sct.v1.Epoch";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "index", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 2, name: "start_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    ]);
    static fromBinary(bytes, options) {
        return new Epoch().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Epoch().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Epoch().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Epoch, a, b);
    }
}
/**
 * Metadata describing the source of a commitment in the state commitment tree.
 *
 * This message allows clients to track provenance of state commitments, and to
 * decide whether or not to download block data.
 *
 * @generated from message penumbra.core.component.sct.v1.CommitmentSource
 */
export class CommitmentSource extends Message {
    /**
     * @generated from oneof penumbra.core.component.sct.v1.CommitmentSource.source
     */
    source = { case: undefined };
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.sct.v1.CommitmentSource";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "transaction", kind: "message", T: CommitmentSource_Transaction, oneof: "source" },
        { no: 2, name: "ics_20_transfer", kind: "message", T: CommitmentSource_Ics20Transfer, oneof: "source" },
        { no: 20, name: "funding_stream_reward", kind: "message", T: CommitmentSource_FundingStreamReward, oneof: "source" },
        { no: 30, name: "community_pool_output", kind: "message", T: CommitmentSource_CommunityPoolOutput, oneof: "source" },
        { no: 40, name: "genesis", kind: "message", T: CommitmentSource_Genesis, oneof: "source" },
    ]);
    static fromBinary(bytes, options) {
        return new CommitmentSource().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CommitmentSource().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CommitmentSource().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CommitmentSource, a, b);
    }
}
/**
 * The state commitment was included in the genesis state.
 *
 * @generated from message penumbra.core.component.sct.v1.CommitmentSource.Genesis
 */
export class CommitmentSource_Genesis extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.sct.v1.CommitmentSource.Genesis";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new CommitmentSource_Genesis().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CommitmentSource_Genesis().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CommitmentSource_Genesis().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CommitmentSource_Genesis, a, b);
    }
}
/**
 * The commitment was created by a transaction.
 *
 * When included in a `CompactBlock` via a `StatePayload`, the transaction source is "dehydrated"
 * by stripping the `id` field and putting empty bytes in its place.  When clients perform extended
 * transaction fetch, they should match up transaction hashes to "rehydrate" the source info.
 *
 * @generated from message penumbra.core.component.sct.v1.CommitmentSource.Transaction
 */
export class CommitmentSource_Transaction extends Message {
    /**
     * The transaction ID, if specified.
     *
     * This field may be omitted to save space, and should not be required to be present.
     * If the bytes are missing, the message should be interpreted as "Transaction (Unknown)".
     *
     * @generated from field: bytes id = 1;
     */
    id = new Uint8Array(0);
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.sct.v1.CommitmentSource.Transaction";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "id", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    ]);
    static fromBinary(bytes, options) {
        return new CommitmentSource_Transaction().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CommitmentSource_Transaction().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CommitmentSource_Transaction().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CommitmentSource_Transaction, a, b);
    }
}
/**
 * The commitment was created through a validator's funding stream.
 *
 * @generated from message penumbra.core.component.sct.v1.CommitmentSource.FundingStreamReward
 */
export class CommitmentSource_FundingStreamReward extends Message {
    /**
     * The epoch index the rewards were issued in.
     *
     * @generated from field: uint64 epoch_index = 1;
     */
    epochIndex = protoInt64.zero;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.sct.v1.CommitmentSource.FundingStreamReward";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "epoch_index", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    ]);
    static fromBinary(bytes, options) {
        return new CommitmentSource_FundingStreamReward().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CommitmentSource_FundingStreamReward().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CommitmentSource_FundingStreamReward().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CommitmentSource_FundingStreamReward, a, b);
    }
}
/**
 * The commitment was created through a `CommunityPoolOutput` in a governance-initated transaction.
 *
 * @generated from message penumbra.core.component.sct.v1.CommitmentSource.CommunityPoolOutput
 */
export class CommitmentSource_CommunityPoolOutput extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.sct.v1.CommitmentSource.CommunityPoolOutput";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new CommitmentSource_CommunityPoolOutput().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CommitmentSource_CommunityPoolOutput().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CommitmentSource_CommunityPoolOutput().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CommitmentSource_CommunityPoolOutput, a, b);
    }
}
/**
 * The commitment was created by an inbound ICS20 transfer.
 *
 * @generated from message penumbra.core.component.sct.v1.CommitmentSource.Ics20Transfer
 */
export class CommitmentSource_Ics20Transfer extends Message {
    /**
     * The sequence number of the packet that triggered the transfer
     *
     * @generated from field: uint64 packet_seq = 1;
     */
    packetSeq = protoInt64.zero;
    /**
     * The channel id the transfer happened on
     *
     * @generated from field: string channel_id = 2;
     */
    channelId = "";
    /**
     * The sender address on the counterparty chain
     *
     * @generated from field: string sender = 3;
     */
    sender = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.sct.v1.CommitmentSource.Ics20Transfer";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "packet_seq", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 2, name: "channel_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 3, name: "sender", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new CommitmentSource_Ics20Transfer().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CommitmentSource_Ics20Transfer().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CommitmentSource_Ics20Transfer().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CommitmentSource_Ics20Transfer, a, b);
    }
}
/**
 * @generated from message penumbra.core.component.sct.v1.Nullifier
 */
export class Nullifier extends Message {
    /**
     * @generated from field: bytes inner = 1;
     */
    inner = new Uint8Array(0);
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.sct.v1.Nullifier";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "inner", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    ]);
    static fromBinary(bytes, options) {
        return new Nullifier().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Nullifier().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Nullifier().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Nullifier, a, b);
    }
}
/**
 * Records information about what transaction spent a nullifier.
 *
 * @generated from message penumbra.core.component.sct.v1.NullificationInfo
 */
export class NullificationInfo extends Message {
    /**
     * @generated from field: bytes id = 1;
     */
    id = new Uint8Array(0);
    /**
     * @generated from field: uint64 spend_height = 2;
     */
    spendHeight = protoInt64.zero;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.sct.v1.NullificationInfo";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "id", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
        { no: 2, name: "spend_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    ]);
    static fromBinary(bytes, options) {
        return new NullificationInfo().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new NullificationInfo().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new NullificationInfo().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(NullificationInfo, a, b);
    }
}
/**
 * Event recording a new commitment added to the SCT.
 *
 * @generated from message penumbra.core.component.sct.v1.EventCommitment
 */
export class EventCommitment extends Message {
    /**
     * @generated from field: penumbra.crypto.tct.v1.StateCommitment commitment = 1;
     */
    commitment;
    /**
     * @generated from field: uint64 position = 2;
     */
    position = protoInt64.zero;
    /**
     * @generated from field: penumbra.core.component.sct.v1.CommitmentSource source = 3;
     */
    source;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.sct.v1.EventCommitment";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "commitment", kind: "message", T: StateCommitment },
        { no: 2, name: "position", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 3, name: "source", kind: "message", T: CommitmentSource },
    ]);
    static fromBinary(bytes, options) {
        return new EventCommitment().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EventCommitment().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EventCommitment().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EventCommitment, a, b);
    }
}
/**
 * Event recording an SCT anchor (global root).
 *
 * @generated from message penumbra.core.component.sct.v1.EventAnchor
 */
export class EventAnchor extends Message {
    /**
     * @generated from field: penumbra.crypto.tct.v1.MerkleRoot anchor = 1;
     */
    anchor;
    /**
     * @generated from field: uint64 height = 2;
     */
    height = protoInt64.zero;
    /**
     * @generated from field: google.protobuf.Timestamp timestamp = 3;
     */
    timestamp;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.sct.v1.EventAnchor";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "anchor", kind: "message", T: MerkleRoot },
        { no: 2, name: "height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 3, name: "timestamp", kind: "message", T: Timestamp },
    ]);
    static fromBinary(bytes, options) {
        return new EventAnchor().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EventAnchor().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EventAnchor().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EventAnchor, a, b);
    }
}
/**
 * Event recording an SCT epoch root.
 *
 * @generated from message penumbra.core.component.sct.v1.EventEpochRoot
 */
export class EventEpochRoot extends Message {
    /**
     * @generated from field: penumbra.crypto.tct.v1.MerkleRoot root = 1;
     */
    root;
    /**
     * @generated from field: uint64 index = 2;
     */
    index = protoInt64.zero;
    /**
     * @generated from field: google.protobuf.Timestamp timestamp = 3;
     */
    timestamp;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.sct.v1.EventEpochRoot";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "root", kind: "message", T: MerkleRoot },
        { no: 2, name: "index", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 3, name: "timestamp", kind: "message", T: Timestamp },
    ]);
    static fromBinary(bytes, options) {
        return new EventEpochRoot().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EventEpochRoot().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EventEpochRoot().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EventEpochRoot, a, b);
    }
}
/**
 * Event recording an SCT block root.
 *
 * @generated from message penumbra.core.component.sct.v1.EventBlockRoot
 */
export class EventBlockRoot extends Message {
    /**
     * @generated from field: penumbra.crypto.tct.v1.MerkleRoot root = 1;
     */
    root;
    /**
     * @generated from field: uint64 height = 2;
     */
    height = protoInt64.zero;
    /**
     * @generated from field: google.protobuf.Timestamp timestamp = 3;
     */
    timestamp;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.sct.v1.EventBlockRoot";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "root", kind: "message", T: MerkleRoot },
        { no: 2, name: "height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 3, name: "timestamp", kind: "message", T: Timestamp },
    ]);
    static fromBinary(bytes, options) {
        return new EventBlockRoot().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EventBlockRoot().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EventBlockRoot().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EventBlockRoot, a, b);
    }
}
/**
 * @generated from message penumbra.core.component.sct.v1.EpochByHeightRequest
 */
export class EpochByHeightRequest extends Message {
    /**
     * @generated from field: uint64 height = 1;
     */
    height = protoInt64.zero;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.sct.v1.EpochByHeightRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    ]);
    static fromBinary(bytes, options) {
        return new EpochByHeightRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EpochByHeightRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EpochByHeightRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EpochByHeightRequest, a, b);
    }
}
/**
 * @generated from message penumbra.core.component.sct.v1.EpochByHeightResponse
 */
export class EpochByHeightResponse extends Message {
    /**
     * @generated from field: penumbra.core.component.sct.v1.Epoch epoch = 1;
     */
    epoch;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.sct.v1.EpochByHeightResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "epoch", kind: "message", T: Epoch },
    ]);
    static fromBinary(bytes, options) {
        return new EpochByHeightResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EpochByHeightResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EpochByHeightResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EpochByHeightResponse, a, b);
    }
}
/**
 * @generated from message penumbra.core.component.sct.v1.AnchorByHeightRequest
 */
export class AnchorByHeightRequest extends Message {
    /**
     * @generated from field: uint64 height = 1;
     */
    height = protoInt64.zero;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.sct.v1.AnchorByHeightRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    ]);
    static fromBinary(bytes, options) {
        return new AnchorByHeightRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AnchorByHeightRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AnchorByHeightRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AnchorByHeightRequest, a, b);
    }
}
/**
 * @generated from message penumbra.core.component.sct.v1.AnchorByHeightResponse
 */
export class AnchorByHeightResponse extends Message {
    /**
     * @generated from field: penumbra.crypto.tct.v1.MerkleRoot anchor = 1;
     */
    anchor;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.sct.v1.AnchorByHeightResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "anchor", kind: "message", T: MerkleRoot },
    ]);
    static fromBinary(bytes, options) {
        return new AnchorByHeightResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AnchorByHeightResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AnchorByHeightResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AnchorByHeightResponse, a, b);
    }
}
/**
 * @generated from message penumbra.core.component.sct.v1.TimestampByHeightRequest
 */
export class TimestampByHeightRequest extends Message {
    /**
     * @generated from field: uint64 height = 1;
     */
    height = protoInt64.zero;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.sct.v1.TimestampByHeightRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    ]);
    static fromBinary(bytes, options) {
        return new TimestampByHeightRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TimestampByHeightRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TimestampByHeightRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TimestampByHeightRequest, a, b);
    }
}
/**
 * @generated from message penumbra.core.component.sct.v1.TimestampByHeightResponse
 */
export class TimestampByHeightResponse extends Message {
    /**
     * @generated from field: google.protobuf.Timestamp timestamp = 1;
     */
    timestamp;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.sct.v1.TimestampByHeightResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "timestamp", kind: "message", T: Timestamp },
    ]);
    static fromBinary(bytes, options) {
        return new TimestampByHeightResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TimestampByHeightResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TimestampByHeightResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TimestampByHeightResponse, a, b);
    }
}
